export const DEFAULT_COMMON_ATTRS = {
  width: '100',
  height: 'auto',
  paddingTop: '16',
  paddingBottom: '16',
  paddingLeft: '16',
  paddingRight: '16',
  marginTop: '8',
  marginBottom: '8',
  marginLeft: '0',
  marginRight: '0'
};

export const getDefaultCommonAttrs = () => ({ ...DEFAULT_COMMON_ATTRS });

export const getDefaultSpecificAttrs = (componentType, theme = { colors: {}, fonts: {} }) => {
  const defaultTheme = {
    colors: { text: '#1E293B', primary: '#3B82F6', border: '#E2E8F0' },
    fonts: { body: 'Inter, sans-serif', heading: 'Inter, sans-serif' }
  };
  
  const t = {
    colors: { ...defaultTheme.colors, ...theme.colors },
    fonts: { ...defaultTheme.fonts, ...theme.fonts }
  };

  const attributeMap = {
    text: {
      content: 'Sample text content',
      fontSize: '16',
      fontWeight: 'normal',
      lineHeight: '1.5',
      textAlign: 'left',
      color: t.colors.text,
      fontFamily: t.fonts.body
    },
    button: {
      text: 'Click me',
      variant: 'primary',
      size: 'medium',
      backgroundColor: t.colors.primary,
      textColor: '#ffffff',
      borderRadius: '8',
      action: 'none',
      actionConfig: {}
    },
    card: {
      title: 'Card Title',
      content: 'Card content goes here',
      backgroundColor: '#ffffff',
      borderRadius: '8',
      borderWidth: '1',
      borderColor: t.colors.border,
      shadow: 'medium',
      nestedComponents: []
    },
    image: {
      src: 'https://via.placeholder.com/400x300',
      alt: 'Sample image',
      objectFit: 'cover',
      borderRadius: '4',
      lazyLoad: true
    },
    input: {
      placeholder: 'Enter text...',
      label: 'Input Label',
      type: 'text',
      required: false,
      disabled: false,
      name: 'input_field',
      validation: 'none'
    },
    select: {
      label: 'Select Label',
      options: 'Option 1,Option 2,Option 3',
      placeholder: 'Choose option...',
      required: false,
      disabled: false,
      name: 'select_field',
      multiple: false
    },
    checkbox: {
      label: 'Checkbox Label',
      checked: false,
      disabled: false,
      name: 'checkbox_field',
      helpText: ''
    },
    custom: {
      componentName: '',
      props: '{}',
      description: 'Custom component configuration',
      importPath: ''
    },
    // NEW COMPONENTS FROM PDF
    paragraph: {
      content: 'This is a paragraph with multiple lines of text. You can add more content here.',
      fontSize: '16',
      lineHeight: '1.6',
      textAlign: 'left',
      color: t.colors.text
    },
    header: {
      text: 'Header Text',
      level: 'h2',
      fontSize: '24',
      fontWeight: 'bold',
      color: t.colors.text,
      alignment: 'left'
    },
    textarea: {
      placeholder: 'Enter your message...',
      label: 'Message',
      rows: 4,
      required: false,
      disabled: false,
      maxLength: 500
    },
    autocomplete: {
      placeholder: 'Search...',
      label: 'Search Field',
      options: 'Apple,Banana,Cherry,Date,Elderberry',
      debounceTime: 300
    },
    radioGroup: {
      label: 'Choose One',
      options: 'Option A,Option B,Option C',
      selectedValue: '',
      name: 'radio_group'
    },
    switch: {
      label: 'Enable Feature',
      checked: false,
      disabled: false,
      size: 'medium'
    },
    number: {
      label: 'Quantity',
      value: 0,
      min: 0,
      max: 100,
      step: 1
    },
    fileUploader: {
      label: 'Upload File',
      accept: '*',
      multiple: false,
      maxSize: 10,
      buttonText: 'Choose File'
    },
    form: {
      title: 'Form Title',
      submitButtonText: 'Submit',
      action: 'none',
      method: 'POST',
      nestedComponents: []
    },
    list: {
      items: 'Item 1,Item 2,Item 3',
      ordered: false,
      itemStyle: 'bullet',
      spacing: 'normal'
    },
    accordion: {
      items: 'Section 1:Content 1,Section 2:Content 2',
      multiExpand: false,
      defaultExpanded: '0'
    },
    tabs: {
      tabs: 'Tab 1,Tab 2,Tab 3',
      activeTab: 0,
      tabPosition: 'top'
    },
    modal: {
      title: 'Modal Title',
      isOpen: false,
      size: 'medium',
      backdrop: true,
      closeButton: true
    },
    video: {
      src: 'https://www.w3schools.com/html/mov_bbb.mp4',
      controls: true,
      autoplay: false,
      loop: false,
      muted: false
    },
    audio: {
      src: 'https://www.w3schools.com/html/horse.mp3',
      controls: true,
      autoplay: false,
      loop: false
    },
    carousel: {
      slides: 'https://via.placeholder.com/800x400/FF6B6B,https://via.placeholder.com/800x400/4ECDC4,https://via.placeholder.com/800x400/45B7D1',
      autoplay: true,
      interval: 3000,
      showIndicators: true,
      showArrows: true
    },
    map: {
      latitude: 37.7749,
      longitude: -122.4194,
      zoom: 13,
      markerLabel: 'San Francisco'
    },
    table: {
      columns: 'Name,Email,Role',
      data: 'John Doe,john@example.com,Admin|Jane Smith,jane@example.com,User',
      sortable: true,
      pagination: false
    },
    chart: {
      type: 'bar',
      data: '10,20,30,40,50',
      labels: 'Jan,Feb,Mar,Apr,May',
      legend: true,
      title: 'Chart Title'
    },
    progressBar: {
      value: 50,
      max: 100,
      color: t.colors.primary,
      striped: false,
      animated: false,
      showLabel: true
    },
    badge: {
      text: 'Badge',
      variant: 'primary',
      size: 'medium',
      color: t.colors.primary
    },
    avatar: {
      src: 'https://via.placeholder.com/100',
      alt: 'User Avatar',
      size: 'medium',
      shape: 'circle'
    },
    alert: {
      type: 'info',
      title: 'Alert Title',
      message: 'This is an alert message.',
      dismissible: true,
      icon: true
    },
    tooltip: {
      text: 'Tooltip text',
      position: 'top',
      trigger: 'hover'
    },
    popover: {
      title: 'Popover Title',
      content: 'Popover content goes here',
      position: 'top',
      trigger: 'click'
    },
    breadcrumb: {
      items: 'Home,Products,Category,Item',
      separator: '/',
      showHome: true
    },
    pagination: {
      currentPage: 1,
      totalPages: 10,
      itemsPerPage: 10,
      showPrevNext: true
    }
  };

  return attributeMap[componentType] || {};
};
